module.exports = __webpack_public_path__ + "img/carousel-mobile-2.da153111.svg";